<template>
  <div class="main-content">
    <div class="card" v-if="tasks && tasks.length">
      <div class="card-header">
        <h5>ЕГК коды на модерации</h5>
      </div>
      <div class="card-body">
        <table class="table table-sm table-hover">
          <thead>
          <tr>
            <th></th>
            <th>ID</th>
            <th>Препарат</th>
            <th>ЕГК</th>
            <th>Новый ЕГК</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(task, i) in tasks">
            <td>{{ i + 1 }}</td>
            <td>{{ task.object_id }}
              <i @click="openDrugEdit(task.object_id)" class="icon-fa icon-fa-edit openEditDrugIcon"/>
            </td>
            <td>{{ task.drug?.title }}</td>
            <td>({{ task.task_data.new_code.id }}) {{ task.task_data.new_code.title }}
<!--              ({{ printDate(code.invalid_date, 'DD.MM.YYYY') }})-->
            </td>
            <td>
              <div v-for="code in getDetailGroup(task?.drug?.details ?? [])" class="flex">
                <div class="pr-2 flex-grow-1">
                  <p>({{ code.id }}) {{ code.title }}</p>
                </div>
                <div>
                  <template v-if="task.task_data.detail_id == code.detail_id">
                    <div class="flex justify-content-between">
                      <div>
                        <LoadingButton
                          title='<i class="icon-fa icon-fa-save"/>'
                          :loading="loadingTaskBtns[task.id]"
                          :onClick="() => updateTask(task.id)"
                          :color="$constants.SUCCESS_COLOR"
                          className="btn btn-outline-success"
                        />
                      </div>
                    </div>
                    <!--                    <div class="">-->
                    <!--                      <EgkSelect ref="egkCodes"-->
                    <!--                                 :hideDetails="true"-->
                    <!--                                 :updateDetail="(d) => addNewCode({id: code.detail_id}, d)"/>-->
                    <!--                    </div>-->
                  </template>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="paginator">
          <p>всего кодов: <strong>{{ paginator.total }}</strong></p>
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <table class="table table-sm table-hover" v-if="records">
          <thead>
          <tr>
            <th></th>
            <th>ID</th>
            <th>Препарат</th>
            <th>ЕГК</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(drug, i) in records">
            <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
            <td>{{ drug.id }}</td>
            <td>{{ drug.title }}</td>
            <td>
              <div v-for="detail in drug.details" v-if="codes[detail.int_value]" class="flex">
                <div class="pr-2">
                  <p>Код: <strong>{{ codes[detail.int_value].id }}</strong></p>
                  <p>Дата деактивации:
                    <strong>{{ printDate(codes[detail.int_value].invalid_date, 'DD.MM.YYYY') }}</strong></p>
                  <p v-if="codes[detail.int_value].valid_id && +codes[detail.int_value].valid_id !== -1">
                    <span class="badge badge-success">Замена <strong>{{
                        codes[detail.int_value].valid_id
                      }}</strong></span>
                  </p>
                </div>
                <div class="flex-grow flex-grow-1">
                  <EgkSelect ref="egkCodes"
                             :hideDetails="true"
                             :updateDetail="(d) => addNewCode(detail, d)"/>
                </div>
                <div class="accept_block">
                  <template v-if="newCodes[detail.id]">
                    <LoadingButton
                      title='<i class="icon-fa icon-fa-save"/>'
                      :loading="loadingBtns[detail.id]"
                      :onClick="() => saveCode(detail.id)"
                      :color="$constants.SUCCESS_COLOR"
                      className="btn btn-outline-success"
                    />
                  </template>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    :page-range="5"
                    :margin-pages="2"
                    :click-handler="getDrugs"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import Paginate from 'vuejs-paginate'
import EgkSelect from "@/views/nomenclature/components/details/EgkSelect";
import LoadingButton from "@/components/buttons/LoadingButton";
import store from "@/store";

export default {
  components: {
    Paginate,
    EgkSelect,
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      tasks: null,
      loadingBtns: {},
      loadingTaskBtns: {},
      paginator: null,
      records: null,
      newCodes: {},
      codes: {},
    }
  },
  created() {
    this.getDrugs();
  },
  methods: {
    getDetailGroup(details) {
      return details.reduce((acc, d) => {
        if (!d.group_parent_id) d.group_parent_id = 0;
        if (!acc[d.group_parent_id]) acc[d.group_parent_id] = {};
        if (d.alias === 'id') {
          acc[d.group_parent_id].detail_id = d.id;
        }
        acc[d.group_parent_id][d.alias] = d[d.type + '_value'];
        return acc;
      }, {})
    },
    openDrugEdit(drugId) {
      // console.log(drugId);
      store.dispatch('modals/setSideData', {drugId: drugId, type: 'editDrug'})
    },
    async updateTask(taskId) {
      this.loadingTaskBtns[taskId] = true;
      this.loadingTaskBtns = {...this.loadingTaskBtns};
      const {data} = await api.post('/tasks/update', {
        task_id: taskId,
        type: 'acceptEgkValidation'
      })
      if (data.success) {
        toastr['success'](data.message || 'Сохранено');
        this.tasks = this.tasks.filter((t) => r.id !== +taskId);
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      // this.loadingTaskBtns[taskId] = false;
    },
    async saveCode(detailId) {
      this.loadingBtns[detailId] = true;
      const {data} = await api.post('/tasks/new', {
        type: 'validateEgkCode',
        drug_id: this.newCodes[detailId].detail.drug_id,
        detail_id: this.newCodes[detailId].detail.id,
        new_code: this.newCodes[detailId].code
      })
      if (data.success) {
        toastr['success'](data.message || 'Сохранено');
        this.records.forEach((r, i) => {
          if (r.id === this.newCodes[detailId].detail.drug_id) {
            this.records[i].details = this.records[i].details.filter((d) => d.id !== +detailId);
          }
        })
        delete this.newCodes[detailId];
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loadingBtns[detailId] = false;
    },
    addNewCode(detail, code) {
      if (!code) {
        delete this.newCodes[detail.id];
      } else {
        this.newCodes[detail.id] = {
          detail,
          code
        }
        this.loadingBtns[detail.id] = false;
      }
      this.newCodes = {...this.newCodes}
      this.loadingBtns = {...this.loadingBtns}
    },
    async getDrugs(page = 1) {
      this.loading = true;
      this.records = null;
      const {data: r_data} = await api.index('/egk/noactive?page=' + page);
      const {data, ...pagination} = r_data.records;
      this.codes = r_data.egkCodes;
      this.paginator = pagination;
      this.records = data;
      this.tasks = r_data.tasks;
      this.loading = false;
    }
  }
}
</script>

<style scoped>
table.table td {
  padding: 3px;
}

.accept_block {
  width: 70px;
  text-align: center;
}

.title {
  width: 300px;
}

.flex-grow {
  min-width: 270px;
}

.openEditDrugIcon {
  color: white;
  background-color: #5bbfde;
  padding: 3px 4px;
  cursor: pointer;
  font-weight: 700;
  border-radius: 4px;
  text-align: center;
}
</style>
